import React from "react";
import { Row, TextInput } from "./fields";

/** Email is the account key, so it is read-only once created. */
const IdentitySection = ({ form, lockEmail }: { form: any; lockEmail: boolean }) => (
  <Row>
    <TextInput id="email" label="Email" form={form} disabled={lockEmail} />
    <TextInput id="first_name" label="First Name" form={form} />
    <TextInput id="last_name" label="Last Name" form={form} />
  </Row>
);

export default IdentitySection;
